import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAspectRatio from './VaAspectRatio.vue'

export const VaAspectRatio = withConfigTransport(_VaAspectRatio)
